<template>
  <div class="relative inline-block w-full" @click.stop>
    <button type="button" class="select-trigger" :class="{ 'select-trigger--disabled': disabled }" @click="toggle">
      <span class="truncate">
        {{ selectedLabel || placeholder }}
      </span>
      <span class="chevron" :class="{ 'chevron--open': isOpen }"></span>
    </button>
    <div v-if="isOpen" class="select-menu">
      <div
        v-for="option in options"
        :key="option.value"
        class="select-option"
        :class="{ 'select-option--active': option.value === value }"
        @click.stop="select(option.value)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectDropdown",
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    selectedLabel() {
      const option = this.options.find((o) => o.value === this.value);
      return option ? option.label : "";
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },
    select(val) {
      if (this.disabled) return;
      if (val === this.value) {
        this.isOpen = false;
        return;
      }
      this.$emit("input", val);
      this.$emit("change", val);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.select-trigger {
  @apply w-full flex items-center justify-between px-2 py-1 text-sm;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #0000001a;
  color: var(--primary-text);
  min-height: 27px;
  outline: none;
}

.select-trigger--disabled {
  opacity: 0.6;
  cursor: default;
}
.chevron {
  width: 7px;
  height: 7px;
  border-right: 2px solid var(--primary-text);
  border-bottom: 2px solid var(--primary-text);
  transform: rotate(45deg);
  transition: transform 0.2s ease;
}
.chevron--open {
  transform: rotate(-135deg);
}
.select-menu {
  @apply absolute mt-1 w-full rounded-xl shadow-lg text-sm;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #0000001a;
  z-index: 30;
  overflow: hidden;
}
.select-option {
  @apply px-4 py-2 cursor-pointer;
}
.select-option:hover {
  background-color: var(--neutral-background-3);
}
.select-option--active {
  background-color: var(--neutral-background-4);
  font-weight: 500;
}
</style>
